import { render, staticRenderFns } from "./PublishedNoteModal.vue?vue&type=template&id=6f3b3bcc&"
import script from "./PublishedNoteModal.vue?vue&type=script&lang=js&"
export * from "./PublishedNoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports